import UITable from '../../../components/UITable';
import { assignableRoles } from '../../../common/Util';
import {
  SelectDropdown,
  SelectItem,
} from '../../../ui/dropdowns/select-dropdown';
import { map, head } from 'lodash';
import { messages } from '../../../i18n';
import {
  AdministrationTableWrapper,
  ProfileImage,
} from './administration-table.styles';
import { asTableColumn } from '../../../datasets/utils';

export const AdministrationTable = ({ list, onRoleChange }) => {
  return (
    <AdministrationTableWrapper>
      <UITable data={list} domain='administration'>
        {({ HeaderRendererWithSort, HorizontalCellInteractive }) => {
          const HorizontalCell = HorizontalCellInteractive;
          const columns = [
            {
              width: 260,
              maxWidth: 260,
              label: messages.administration.tableNameColumn,
              key: 'fullName',
              dataKey: 'fullName',
              cellRenderer: ({ rowData }) => (
                <HorizontalCell>
                  <ProfileImage src={undefined} />
                  {rowData.fullName}
                </HorizontalCell>
              ),
              headerRenderer: HeaderRendererWithSort,
            },
            {
              width: 160,
              maxWidth: 160,
              label: messages.administration.tableRoleColumn,
              key: 'role',
              dataKey: 'role',
              cellRenderer: ({ rowData }) => {
                return (
                  <HorizontalCell style={{ containerType: 'normal', flex: 1 }}>
                    <SelectDropdown
                      title={
                        messages.idmUserRoles[head(rowData.roles as string[])]
                      }
                      headerSx={{ width: '100%' }}
                      disablePortal={false}
                      popperSx={{
                        zIndex: 1050,
                      }}
                    >
                      {map(assignableRoles, role => (
                        <SelectItem onClick={() => onRoleChange(rowData, role)}>
                          {messages.idmUserRoles[role]}
                        </SelectItem>
                      ))}
                    </SelectDropdown>
                  </HorizontalCell>
                );
              },
              disableSort: true,
            },
            {
              width: 160,
              maxWidth: 160,
              label: '',
              key: 'actions',
              dataKey: 'actions',
              cellRenderer: ({ rowData }) => (
                <HorizontalCell>{rowData.actions}</HorizontalCell>
              ),
              disableSort: true,
            },
          ].filter(Boolean);

          return map(columns, asTableColumn);
        }}
      </UITable>
    </AdministrationTableWrapper>
  );
};
